import { CSSProperties, useEffect, useState } from "react";
import { Airport } from "../../models/airport";
import "./index.css";

interface AirportSuggestionProps {
  airports: Airport[];
  term: string;
  visible: boolean;
  position: "top" | "bottom";
  onSelect: (airport: Airport) => void;
}

export const AirportSuggestion = ({
  airports,
  term,
  visible,
  position,
  onSelect,
}: AirportSuggestionProps) => {
  const [filteredAirports, setFilteredAirports] = useState<Airport[]>([]);
  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  const style: CSSProperties = {
    position: "absolute",
    width: "100%",
    display: visible && term.length > 0 ? "block" : "none",
    maxHeight: "200px",
    overflowY: "auto",
    scrollbarWidth: "none",
    pointerEvents: "all",
    ...(isMobile
      ? {}
      : {
          top: position === "top" ? "0" : "-105%",
          left: "103%",
        }),
  };

  const liStyle: CSSProperties = {
    padding: "10px",
    backgroundColor: "white",
    width: "100%",
    borderBottom: "1px solid #ccc",
    cursor: "pointer",
    pointerEvents: "all",
    listStyle: "none",
  };

  useEffect(() => {
    setFilteredAirports(
      airports
        .filter(
          (airport) =>
            airport.name &&
            airport.city &&
            airport.iata &&
            (airport.name.toLowerCase().includes(term.toLowerCase()) ||
              airport.city.toLowerCase().includes(term.toLowerCase()) ||
              airport.iata.toLowerCase().includes(term.toLowerCase()))
        )
        .slice(0, 10)
    );
  }, [term, airports]);

  return (
    <ul style={style}>
      {filteredAirports.map((airport) => (
        <li style={liStyle} key={airport.id} onClick={() => onSelect(airport)}>
          <h1>{airport.name}</h1>
          <h2 style={{ fontSize: "sm", fontFamily: "sans-serif" }}>
            {airport.country_emoji} {airport.daily_departures} flights
          </h2>
        </li>
      ))}
    </ul>
  );
};
